/* Tropical signs; true ecliptic of date. No houses, aspects or inferred birth times. */
(() => {
 'use strict';
 const A=window.Astronomy,signs=['Aries','Taurus','Gemini','Cancer','Leo','Virgo','Libra','Scorpio','Sagittarius','Capricorn','Aquarius','Pisces'];
 const norm=n=>(n%360+360)%360;
 function ascendant(date,lat,lon){
  if(!Number.isFinite(lat)||!Number.isFinite(lon)||Math.abs(lat)>90||Math.abs(lon)>180)throw Error('Enter valid birthplace coordinates.');
  if(Math.abs(lat)>=66)return null;
  const observer=new A.Observer(lat,lon,0),hor=A.Rotation_HOR_EQD(date,observer),ecl=A.Rotation_EQD_ECT(date);
  const rotate=(x,y,z)=>A.RotateVector(ecl,A.RotateVector(hor,new A.Vector(x,y,z,date)));
  const up=rotate(0,0,1),east=rotate(0,-1,0);let x=-up.y,y=up.x;
  if(Math.hypot(x,y)<1e-10)return null;
  if(x*east.x+y*east.y<0){x=-x;y=-y;}
  return norm(Math.atan2(y,x)*180/Math.PI);
 }
 function placements(start,end,lat,lon,mode){
  const bodies=['Sun','Moon','Rising'],values=bodies.map(body=>({body,signs:[],longitude:null}));
  const sample=date=>values.forEach(v=>{
   const longitude=v.body==='Rising'?(mode==='unknown'?null:ascendant(date,lat,lon)):A.Ecliptic(A.GeoVector(v.body,date,true)).elon;
   if(longitude===null)return;
   const sign=signs[Math.floor(norm(longitude)/30)];if(!v.signs.includes(sign))v.signs.push(sign);if(!end)v.longitude=norm(longitude);
  });
  if(!end)sample(start);else{const step=mode==='approximate'?60000:900000;for(let t=+start;t<+end;t+=step)sample(new Date(t));sample(new Date(+end-1));}
  return values;
 }
 window.BigThreeMath={ascendant,placements,signs};
})();
